(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-personal-otras', {
                parent: 'entity',
                url: '/consortium-personal-otras?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumPersonalOtra'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-personal/consortium-personal-otras/consortium-personal-otras.html',
                    controller: 'ConsortiumPersonalOtraController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-personal-otras.new', {
                parent: 'consortium-personal-otras',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-personal/consortium-personal-otras/consortium-personal-otras-new.html',
                    controller: 'ConsortiumPersonalOtraNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-personal-otras'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-personal-otras',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-personal-otras.edit', {
                parent: 'consortium-personal-otras',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumPersonalOtra'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-personal/consortium-personal-otras/consortium-personal-otras-detail.html',
                        controller: 'ConsortiumPersonalOtraDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-personal-otras'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumPersonalOtra', function($stateParams, ConsortiumPersonalOtra) {
                        return ConsortiumPersonalOtra.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-personal-otras',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();
